// /root/ve-meet-staging/client/src/HostAccess.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HostAccess.css";

export default function HostAccess() {
  const navigate = useNavigate();
  const [inputCode, setInputCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleJoin = async () => {
    setError("");
    const code = (inputCode || "").trim();
    if (!code) {
      setError("Please enter a host code.");
      return;
    }

    setLoading(true);
    try {
      // Call server validate endpoint (server will mark code as Used)
      const res = await fetch("/api/hostCodes/validateHostCode", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code })
      });

      if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        setError(json.error || "Invalid Host Code. Please check or ask Admin for a code.");
        setLoading(false);
        return;
      }

      const data = await res.json();
      const hostPlan = data.plan || "free";
      const hostName = "Host"; // or prompt later
      const roomId = data.code;

      sessionStorage.setItem("roomId", roomId);
      sessionStorage.setItem("hostName", hostName);
      sessionStorage.setItem("hostPlan", hostPlan);

      navigate(`/room?roomId=${encodeURIComponent(roomId)}&name=${encodeURIComponent(hostName)}&plan=${encodeURIComponent(hostPlan)}`);
    } catch (err) {
      console.error("HostAccess handleJoin error:", err);
      setError("Server error validating code. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hostaccess-container">
      <h2>Enter Host Code</h2>

      <input
        type="text"
        placeholder="Enter Host Code"
        value={inputCode}
        onChange={(e) => setInputCode(e.target.value)}
      />

      {error && <p className="error">{error}</p>}

      <button onClick={handleJoin} disabled={loading}>
        {loading ? "Checking…" : "Host Meeting"}
      </button>
    </div>
  );
}
